module.exports = __webpack_public_path__ + "static/media/WechatIMG3842@2x.f9802a15.jpg";